import { IItemCommercialTranslationState } from '@/store/itemcommercialtranslation';
import { IItemCommercialTranslationGetters } from './getters.types';
import {
  IItemCommercialTranslation,
  ItemCommercialTranslation
} from '@/models';

export const getters: IItemCommercialTranslationGetters = {
  getItemCommercialTranslations(
    state: IItemCommercialTranslationState
  ): IItemCommercialTranslation[] {
    return state.itemCommercialTranslations.map(
      data => new ItemCommercialTranslation(data)
    );
  },

  getItemCommercialTranslationById: (
    state: IItemCommercialTranslationState
  ) => (id: number): IItemCommercialTranslation | undefined => {
    const data = state.itemCommercialTranslations.find(
      itemCommercialTranslation => itemCommercialTranslation.id === id
    );
    if (!data) {
      return undefined;
    }

    return new ItemCommercialTranslation(data);
  },

  getItemCount(state: IItemCommercialTranslationState): number {
    return state.count;
  }
};
